// // RegisterCompanion.jsx
// export default function RegisterCompanion() {
//   return (
//     <div className="text-white bg-black h-screen flex items-center justify-center">
//       <h1 className="text-2xl font-bold">Register: AI Mental Health Companion</h1>
//     </div>
//   );
// }

import { useNavigate } from "react-router-dom";
import { useState, useContext } from "react";
import Navbar from "../Navbar";
import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import plutonicSmallName from "../../assets/images/plutonicSmallName.svg";
import plutonicLogo from "../../assets/images/plutonicLogo.svg";
import { AuthContext } from "../../context/AuthContext";
import { useAgeValidation } from "../../hooks/useAgeValidation";
import Env from "../../runtimeEnv";

const states = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

function RegisterCompanion() {
  const {
    currentNickname,
    setCurrentNickname,
    handleLogout,
    PlutonicuserID,
    userType,
    currentFormType,
    setCurrentFormType,
  } = useContext(AuthContext);

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    age: "",
    state: "",
    password: "",
    userType: "client-ai-companion",
  });

  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { ageError, validateAge } = useAgeValidation(18);

  const [passwordRequirements, setPasswordRequirements] = useState({
    minLength: false,
    hasNumber: false,
    hasSpecialChar: false,
    hasUppercase: false,
    hasLowercase: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "age" && !/^\d*$/.test(value)) return;
    if (name === "age") validateAge(value);

    if (name === "password") {
      const val = value;
      setPasswordRequirements({
        minLength: val.length >= 8,
        hasNumber: /[0-9]/.test(val),
        hasSpecialChar: /[!@#$%^&*]/.test(val),
        hasUppercase: /[A-Z]/.test(val),
        hasLowercase: /[a-z]/.test(val),
      });
    }

    setFormData((f) => ({
      ...f,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      const response = await axios.post(
        `${Env.REACT_APP_PYTHON_API_URL}/api/register`,
        formData,
        {
          withCredentials: true,
        }
      );

      if (response.status === 201) {
        setSuccess("Registration successful! Redirecting to login...");
        setTimeout(() => navigate("/"), 2000);
      }
    } catch (err) {
      const msg = err.response?.data?.message || "Registration failed.";
      setError(msg);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center bg-gradient-to-b from-[#4e345d] to-[#6EDDE6] px-4 py-8">
      <Navbar
        currentNickname={currentNickname}
        handleLogout={handleLogout}
        setCurrentFormType={setCurrentFormType}
        showButtons={false}
        PlutonicuserID={PlutonicuserID}
      />

      <form
        onSubmit={handleSubmit}
        autoComplete="off"
        className="mt-[100px] w-full max-w-sm bg-black/80 rounded-3xl shadow-lg p-5 sm:p-6 text-white text-center"
      >
        <h2 className="text-xl font-bold mb-4">Register for AI Companion</h2>

        {/* First Name */}
        <input
          name="firstName"
          placeholder="First Name"
          value={formData.firstName}
          onChange={handleChange}
          className="w-full mb-3 h-[48px] px-4 bg-transparent border border-gray-400 rounded-full text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#22AAEE]"
          required
        />

        {/* Last Name */}
        <input
          name="lastName"
          placeholder="Last Name"
          value={formData.lastName}
          onChange={handleChange}
          className="w-full mb-3 h-[48px] px-4 bg-transparent border border-gray-400 rounded-full text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#22AAEE]"
          required
        />

        {/* Email */}
        <input
          name="email"
          autoComplete="off"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          className="w-full mb-3 h-[48px] px-4 bg-transparent border border-gray-400 rounded-full text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#22AAEE]"
          required
        />

        {/* Age */}
        <div className="mb-3">
          <input
            name="age"
            placeholder="Age"
            value={formData.age}
            onChange={handleChange}
            className="w-full h-[48px] px-4 bg-transparent border border-gray-400 rounded-full text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#22AAEE]"
            required
          />
          {ageError && (
            <p className="text-red-400 text-xs mt-1 text-left px-2">
              {ageError}
            </p>
          )}
        </div>

        {/* State Dropdown */}
        <div className="mb-3 relative z-10">
          <div
            className={`w-full h-[48px] px-4 bg-transparent border border-gray-400 rounded-full text-white text-sm placeholder-gray-500 
                focus:outline-none focus:border-[#22AAEE] flex items-center justify-between cursor-pointer ${
                  dropdownOpen ? "ring-2 ring-[#22AAEE]" : ""
                }`}
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <span className={formData.state ? "" : "text-gray-500"}>
              {formData.state || "Select State"}
            </span>
            <svg
              className="w-4 h-4 text-gray-400"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>

          {dropdownOpen && (
            <ul className="absolute w-full mt-1 bg-white text-black rounded-lg shadow-md max-h-60 overflow-y-auto">
              {states.map((state) => (
                <li
                  key={state}
                  onClick={() => {
                    setFormData((prev) => ({ ...prev, state }));
                    setDropdownOpen(false);
                  }}
                  className="px-4 py-2 hover:bg-[#22AAEE] hover:text-white cursor-pointer text-sm"
                >
                  {state}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Password */}
        <div className="mb-3 relative">
          <input
            name="password"
            autoComplete="new-password"
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            className="w-full h-[48px] px-4 bg-transparent border border-gray-400 rounded-full text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#22AAEE]"
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white"
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>
        <div className="text-left text-xs text-white mb-3 px-2">
          <p className="mb-1 font-semibold">
            Password must meet the following requirements:
          </p>
          <ul className="list-disc ml-4 space-y-1">
            <li
              className={
                passwordRequirements.minLength
                  ? "text-green-400"
                  : "text-red-400"
              }
            >
              Minimum 8 characters
            </li>
            <li
              className={
                passwordRequirements.hasNumber
                  ? "text-green-400"
                  : "text-red-400"
              }
            >
              At least 1 number
            </li>
            <li
              className={
                passwordRequirements.hasSpecialChar
                  ? "text-green-400"
                  : "text-red-400"
              }
            >
              At least 1 special character (!@#$%^&*)
            </li>
            <li
              className={
                passwordRequirements.hasUppercase
                  ? "text-green-400"
                  : "text-red-400"
              }
            >
              At least 1 uppercase letter
            </li>
            <li
              className={
                passwordRequirements.hasLowercase
                  ? "text-green-400"
                  : "text-red-400"
              }
            >
              At least 1 lowercase letter
            </li>
          </ul>
        </div>

        {/* Confirm Password */}
        <input
          name="confirmPassword"
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="w-full mb-3 h-[48px] px-4 bg-transparent border border-gray-400 rounded-full text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#22AAEE]"
          required
        />

        {error && <p className="text-red-400 text-sm mb-2">{error}</p>}
        {success && <p className="text-green-400 text-sm mb-2">{success}</p>}
        {/* Consent & Policies */}
        <div className="flex items-start text-xs text-white gap-2 mb-6 text-left">
          <input
            type="checkbox"
            name="agree"
            checked={formData.agree}
            onChange={handleChange}
            className="mt-1 w-4 h-4 accent-white"
            required
          />
          <label htmlFor="agree">
            I agree to the{" "}
            <a
              href="/terms-of-service"
              className="underline font-semibold text-white"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service
            </a>
            ,{" "}
            <a
              href="/privacy-policy"
              className="underline font-semibold text-white"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
            , and{" "}
            <a
              href="/telehealth-consent"
              className="underline font-semibold text-white"
              target="_blank"
              rel="noopener noreferrer"
            >
              Telehealth Consent
            </a>
            , and understand that this service is{" "}
            <span className="font-semibold">not for emergency use</span>.
          </label>
        </div>

        <button
          type="submit"
          className="w-full h-[48px] px-4 border border-[#22AAEE] text-[#22AAEE] font-bold rounded-full transition duration-200 hover:bg-[#22AAEE] hover:text-white text-sm"
        >
          SIGN UP
        </button>

        <div className="mt-2 flex items-center justify-center space-x-2">
          <img
            src={plutonicLogo}
            alt="Plutonic Logo"
            className="w-[50px] h-[30px]"
          />
          <img
            src={plutonicSmallName}
            alt="company name"
            className="w-20 h-20"
          />
        </div>
      </form>
    </div>
  );
}

export default RegisterCompanion;
